const fullCalendar = import('fullcalendar');
import TeamCalendarCell from '../../teams/calendar/partials/TeamCalendarCell';
import AdveritserCalendarCell from '../../advertisers/calendar/partials/AdvertiserCalendarCell';
import PriceModifierField from '../../teams/inventory/pricing/PriceModifierField';
import PostedAssetSpot from '../../teams/inventory/posted/PostedAssetSpot';

const AdveritserCalendarCellClass = Vue.extend(AdveritserCalendarCell);
const TeamCalendarCellClass = Vue.extend(TeamCalendarCell);

export default {
    components: { PriceModifierField, PostedAssetSpot },
    data() {
        return {
            calendar: {
                loadSchedule: true,
                end_string: null,
                start_string: null,
                calendarDate: moment(),
                selectedStartDate: null,
                selectedEndDate: null,
                canSelectPast: true,
                singleDaySelect: false,
                isLoading: false,
                view: 'month',
                selectedEvent: null,
                selectedPriceModifier: null,
                selectedScheduleDate: null,
                skipEvent: false, // prevents infinite loop in selecting from datepicker
                haveSelection: false,
                meta: null,
                events: null,
                schedule: null,
                start_date: null,
                end_date: null,
                obj: null,
                datePicker: {
                    start: null,
                    end: null,
                },
                datePickers: {
                    start: null,
                    end: null,
                },
            },
        };
    },
    created() {
        const self = this;
        fullCalendar.then(() => {
            self.buildCalendar();
        });
        Bus.$on('allCalendarsRefetch', this.refetchEvents);
    },
    methods: {
        /**
         * Plugin events
         */
        onGetCalendarData() {},
        onCalendarSelection() {},
        afterBuildCalendar() {},
        dayRender(date, cell) {},
        eventRender(event, element) {
            if (this._isTeam) {
                const instance = new TeamCalendarCellClass({
                    propsData: {
                        event: event,
                        element: element,
                        config: { icons: true },
                    },
                });
                instance.$mount();
                element.html(instance.$el);
            }
            if (this._isAdvertiser) {
                const instance = new AdveritserCalendarCellClass({
                    propsData: { event: event, element: element },
                });
                instance.$mount();
                element.html(instance.$el);
            }
        },
        buildCalendar() {
            const _this = this;

            let config = _.merge(
                {},
                {
                    themeSystem: 'bootstrap4',
                    header: {
                        left: 'prev,next today title',
                        right: '',
                    },
                    columnHeaderFormat: 'dddd',
                    showNonCurrentDates: false,
                    allDayDefault: true,
                    selectOverlap: true,
                    selectable: true,
                    unselectCancel: '*',
                    dayRender: _this.dayRender,
                    select: _this.calendarSelectionMade,
                    viewRender: _this.renderCalendarView,
                    eventRender: _this.eventRender,
                    selectAllow: _this.selectAllow,
                    eventSources: [_this.getCalendarData, _this.getSchedule],
                    unselect: this.calendarUnselectionMade,
                },
                _.get(this, 'calendarConfig', {}),
            );

            this.$nextTick(function () {
                this.calendar.obj = $(this.$refs.calendar).fullCalendar(config);
                this.afterBuildCalendar();
            });
        },
        renderCalendarView(view) {
            this.calendar.view = view.name;
            this.calendar.calendarDate = this.calendar.obj ? this.calendar.obj.fullCalendar('getDate') : moment();
        },
        refetchEvents() {
            this.calendar.obj.fullCalendar('refetchEvents');
        },
        selectAllow(selectInfo) {
            if (!this.calendar.canSelectPast) {
                if (selectInfo.end.isBefore(moment())) {
                    return false;
                }
            }

            if (this.calendar.singleDaySelect) {
                return selectInfo.end.diff(selectInfo.start, 'hours') <= 24;
            }

            return true;
        },
        clearCalendarSelection() {
            this.calendar.start_date = null;
            this.calendar.end_date = null;
            this.calendar.haveSelection = false;
        },
        getPriceModifierByDate(date) {
            const _this = this;

            if (this.singleDaySelected) {
                this.calendar.selectedScheduleDate = _.find(_this.calendar.schedule, (item) => {
                    return item.start === dateTimeString(date, 'YYYY-MM-DD');
                });

                this.calendar.selectedPriceModifier = _.get(this.calendar.selectedScheduleDate, 'price_modifier', null);
                this.$store.commit('calendars/addToSelection', {
                    key: 'priceModifier',
                    value: this.calendar.selectedPriceModifier,
                });
            } else {
                this.calendar.selectedPriceModifier = null;
                this.calendar.selectedScheduleDate = null;
                this.$store.commit('calendars/addToSelection', {
                    key: 'priceModifier',
                    value: null,
                });
            }

            return this.calendar.selectedPriceModifier;
        },
        getEventByDate(date) {
            const _this = this;

            if (this.singleDaySelected) {
                this.calendar.selectedEvent = _.find(_this.calendar.events, (item) => {
                    return moment(item.start).format('YYYY-MM-DD') === date.format('YYYY-MM-DD');
                });
                this.$store.commit('calendars/addToSelection', {
                    key: 'event',
                    value: this.calendar.selectedEvent,
                });
            } else {
                this.calendar.selectedEvent = null;
                this.$store.commit('calendars/addToSelection', {
                    key: 'event',
                    value: null,
                });
            }

            return this.calendar.selectedEvent;
        },
        calendarUnselectionMade() {
            this.calendar.haveSelection = false;
            this.calendar.selectedStartDate = null;
            this.calendar.selectedEndDate = null;
        },
        calendarSelectionMade(start, end, e) {
            this.calendar.start_date = moment(start);
            this.calendar.end_date = moment(end);
            this.calendar.start_string = start.clone().startOf('day').format('YYYY-MM-DD');
            this.calendar.end_string = start.isSame(end, 'day')
                ? end.clone().startOf('day').format('YYYY-MM-DD')
                : end.clone().startOf('day').subtract(1, 'day').format('YYYY-MM-DD');
            this.calendar.selectedEvent = null;
            this.calendar.selectedPriceModifier = null;
            this.calendar.selectedScheduleDate = null;

            if (e) {
                this.calendar.skipEvent = true;
                Vue.set(this.calendar.datePickers, 'start', this.calendar.start_string);
                Vue.set(this.calendar.datePickers, 'end', this.calendar.end_string);
            }

            this.$nextTick(function () {
                this.calendar.selectedStartDate = _.find(this.calendar.schedule, (item) => {
                    return item.start === start.format('YYYY-MM-DD');
                });
                this.$store.commit('calendars/addToSelection', {
                    key: 'startDate',
                    value: this.calendar.selectedStartDate,
                });

                this.calendar.selectedEndDate = _.find(this.calendar.schedule, (item) => {
                    return item.start === end.format('YYYY-MM-DD');
                });
                this.$store.commit('calendars/addToSelection', {
                    key: 'endDate',
                    value: this.calendar.selectedEndDate,
                });

                this.getEventByDate(start);
                this.getPriceModifierByDate(start);
                this.onCalendarSelection(start, end, e);
                this.$nextTick(function () {
                    this.calendar.haveSelection = true;
                });
            });
        },
        getCalendarData(start, end, timezone, callback) {
            const _this = this;
            this.calendar.isLoading = true;
            if (this.dataUrl) {
                let params = _.merge(
                    {},
                    {
                        start: start.format(),
                        end: end.format(),
                    },
                    _.get(this, 'calendarConfig.params', {}),
                );

                axios
                    .get(this.dataUrl, {
                        params: params,
                    })
                    .then((response) => {
                        _this.calendar.events = _this.$vueData.getData(response);
                        _this.calendar.meta = _this.$vueData.getMeta(response);
                        _this.onGetCalendarData(_this.calendar.events, start, end);
                        callback(_this.calendar.events);
                    })
                    .finally(() => {
                        _this.calendar.isLoading = false;
                    });
            } else {
                _this.calendar.isLoading = false;
                _this.calendar.events = [];
                _this.onGetCalendarData(_this.calendar.events, start, end);
                callback(_this.calendar.events);
            }
        },
        getSchedule(start, end, timezone, callback) {
            const _this = this;

            if (!this.calendar.loadSchedule) {
                return callback([]);
            }

            let params = _.merge(
                {},
                {
                    start: start.format(),
                    end: end.format(),
                },
                _.get(this, 'calendarConfig.params', {}),
            );

            axios
                .get('/api/team/schedule-dates', {
                    params: params,
                })
                .then((response) => {
                    _this.calendar.schedule = response.data.data;
                    _this.$store.commit('calendars/addToSelection', {
                        key: 'scheduleDates',
                        value: _this.calendar.schedule,
                    });
                    callback(
                        _.map(_this.calendar.schedule, (item) => {
                            return _this.formatScheduleDate(item);
                        }),
                    );
                });
        },
        formatScheduleDate(date) {
            return date;
        },
    },
    computed: {
        singleDaySelected() {
            return this.calendar.start_date && this.calendar.end_date ? Math.abs(this.calendar.start_date.diff(this.calendar.end_date, 'hours')) <= 24 : false;
        },
        dataUrl() {
            return null;
        },
        calendarSelectionEditable() {
            if (this.singleDaySelected) {
                return _.get(this.calendar, 'selectedStartDate.editable', 1);
            }

            return _.get(this.calendar, 'selectedStartDate.editable', 1) || _.get(this.calendar, 'selectedEndDate.editable', 1);
        },
    },
    watch: {
        'calendar.datePickers': {
            deep: true,
            handler: function (newVal) {
                if (newVal && newVal.start && newVal.end && !this.calendar.skipEvent) {
                    let end = $.fullCalendar.moment(newVal.end);
                    let start = $.fullCalendar.moment(newVal.start);
                    this.calendar.obj.fullCalendar('gotoDate', start.stripTime());
                    this.calendar.obj.fullCalendar('select', start.stripTime(), end.add(1, 'day').stripTime());
                } else {
                    this.$nextTick(function () {
                        this.calendar.skipEvent = false;
                    });
                }
            },
        },
    },
};
